import { ref } from '@vue/composition-api';
import { nextTick } from '@/_core/utils/nextTick';
import { createDebugger } from '@/_core/utils/debug';
const debug = createDebugger('utils:useIsOpen');

export function useIsOpen() {
    const isOpen = ref(false);

    const open = () => {
        isOpen.value = true;
    };

    const close = () => {
        isOpen.value = false;
    };

    const reOpen = async () => {
        debug('reopen useisopen');

        isOpen.value = false;
        await nextTick();
        isOpen.value = true;
    };

    return {
        isOpen,
        open,
        close,
        reOpen,
    };
}
